import React from 'react';
import { FlatList, View, StyleSheet, Image, Linking, TouchableOpacity, Platform } from 'react-native';
let SvgUri;
if (Platform.OS !== 'web') {
    const RNSVG = require('react-native-svg');
    SvgUri = RNSVG?.SvgUri;
}
import { GREEN_BOOK_ICON, VOLT, blog1, blog1Url, blog2Url, blog3Url, WATCH_VIDEO_ICON, llsVideoUrl, llaBannerUrl } from './constant';
import Typography from '../../typography/Typography';
import { ColorTokens, FontFamilyTokens, FontSizeTokens } from '@voltmoney/schema';
const HorizontalScrollScreen = () => {
    const data = [
        { key: '1', text: 'See why Labour Law Advisor recommends loan against MF', iconUrl: WATCH_VIDEO_ICON, imageUrl: llaBannerUrl, url: llsVideoUrl, subText: 'Watch now' },
        { key: '2', text: 'Don’t redeem, take a loan against MF (via mint)', iconUrl: GREEN_BOOK_ICON, imageUrl: blog1, url: blog1Url, subText: 'Read now' },
        { key: '2', text: 'Why you should take a loan against you Mutual Funds', iconUrl: GREEN_BOOK_ICON, imageUrl: VOLT, url: blog2Url, subText: 'Read now' },
        { key: '3', text: 'Borrow smartly: LAMF vs. Personal Loans', iconUrl: GREEN_BOOK_ICON, imageUrl: VOLT, url: blog3Url, subText: 'Read now' },
    ];
    const handleUrl = (url) => {
        Linking.openURL(url)
            .then((result) => {
            console.log('Opened URL successfully:', result);
        })
            .catch((error) => {
            console.error('Error opening URL:', error);
        });
    };
    const renderItem = ({ item }) => (React.createElement(View, null,
        React.createElement(View, { style: styles.iconContainer },
            React.createElement(Image, { source: { uri: item.iconUrl }, style: {
                    width: 42,
                    height: 42
                } })),
        React.createElement(View, { style: styles.container },
            React.createElement(View, null,
                React.createElement(Image, { source: { uri: item.imageUrl }, style: styles.image })),
            React.createElement(View, { style: styles.textContainer },
                React.createElement(Typography, { label: item.text, fontSize: FontSizeTokens.XS, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night, lineHeight: 18, numberOfLines: 2 })),
            React.createElement(View, { style: styles.urlContainer, nativeID: `txt_landingScreen_readNow${item.key}` },
                React.createElement(TouchableOpacity, { onPress: () => handleUrl(item.url) },
                    React.createElement(Typography, { label: item.subText, fontSize: FontSizeTokens.XS, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Primary_100, lineHeight: 18 }))))));
    return (React.createElement(View, { style: styles.flatListContainer },
        React.createElement(FlatList, { horizontal: true, data: data, renderItem: renderItem, keyExtractor: (item) => item.key, showsHorizontalScrollIndicator: false })));
};
export default HorizontalScrollScreen;
const styles = StyleSheet.create({
    container: {
        backgroundColor: 'white',
        marginTop: 37,
        borderRadius: 8,
        marginRight: 20,
        width: 208,
    },
    flatListContainer: {
        marginLeft: 16,
    },
    image: {
        width: 208,
        height: 77,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
    },
    iconContainer: {
        paddingLeft: 15,
        backgroundColor: 'red',
        height: 0,
        marginBottom: -16,
        zIndex: 1,
        marginTop: 16
    },
    textContainer: {
        marginTop: 15,
        paddingLeft: 16,
        paddingRight: 9,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
    },
    urlContainer: {
        marginTop: 6,
        paddingLeft: 15,
        paddingBottom: 16,
    },
    urlText: {
        fontSize: 12,
        fontWeight: '600',
        fontFamily: 'Inter',
        color: '#1434CB',
        lineHeight: 18
    },
});
